const images = [
  {
    url: "https://ik.imagekit.io/cabanasdelcampo/interiores/20250113_115740.jpg?updatedAt=1737417477653",
    title: "Habitación Principal",
    description:
      "Dormitorio amplio y confortable con capacidad para hasta 4 personas",
  },
  {
    url: "https://ik.imagekit.io/cabanasdelcampo/interiores/20250113_102009.jpg?updatedAt=1737417457043",
    title: "Sala de Estar",
    description:
      "Espacio acogedor con sillones y chimenea para disfrutar en familia",
  },
  {
    url: "https://ik.imagekit.io/cabanasdelcampo/interiores/20250113_102643.jpg?updatedAt=1737417458419",
    title: "Cocina Equipada",
    description: "Cocina completa con todos los electrodomésticos necesarios",
  },
  {
    url: "https://ik.imagekit.io/cabanasdelcampo/interiores/20250113_111641.jpg?updatedAt=1737417460930",
    title: "Espacios Exteriores",
    description:
      "Amplios jardines y galería con asador para disfrutar del aire libre",
  },
  {
    url: "https://ik.imagekit.io/cabanasdelcampo/interiores/WhatsApp%20Image%202025-01-25%20at%2013.30.30.jpeg?updatedAt=1737825824394",
    title: "Espacios Exteriores",
    description:
      "Amplios jardines y galería con asador para disfrutar del aire libre",
  },
  {
    url: "https://ik.imagekit.io/cabanasdelcampo/interiores/20250113_100933.jpg?updatedAt=1737417457339",
    title: "Espacios Exteriores",
    description:
      "Amplios jardines y galería con asador para disfrutar del aire libre",
  },
  {
    url: "https://ik.imagekit.io/cabanasdelcampo/interiores/20250113_105547.jpg?updatedAt=1737417460606",
    title: "Espacios Exteriores",
    description:
      "Amplios jardines y galería con asador para disfrutar del aire libre",
  },
];

export default images;
